import { FETCH_SERVICES } from '../actions/ServicesAction';

const initialState = {
  services: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_SERVICES:
      return {
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/ServicesReducer.js